import { Collapse, Space, Typography } from "antd";
import { useT } from "../i18n/context";

const { Text } = Typography;

interface ThinkingBlockProps {
  content: string;
  /** 是否处于"思考中"状态（流式时为 true） */
  isActive?: boolean;
}

export default function ThinkingBlock({ content, isActive }: ThinkingBlockProps) {
  const t = useT();
  return (
    <Collapse
      ghost
      size="small"
      style={{ width: "100%", marginBottom: 4 }}
      items={[
        {
          key: "thinking",
          label: (
            <Space size={6}>
              {isActive && (
                <span
                  style={{
                    display: "inline-block",
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    background: "var(--lude-im-success)",
                    animation: "lude-im-pulse 1.5s infinite",
                  }}
                />
              )}
              <Text type="secondary" style={{ fontSize: 12 }}>
                💭 {t("chat.thinking")}
                {isActive ? "..." : ""}
              </Text>
            </Space>
          ),
          children: (
            <div style={{ maxHeight: 200, overflow: "auto" }}>
              <Text
                type="secondary"
                style={{
                  fontSize: 12,
                  fontStyle: "italic",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}
              >
                {content}
              </Text>
            </div>
          ),
        },
      ]}
    />
  );
}
